import { useCallback } from 'react';

export type ComboBoxOption = {
  key: string;
  namespace: string;
  uniqueValue: string;
  hasPluralization: boolean;
};

export const useComboboxOptions = () => {
  const createUniqueValue = useCallback(
    ({ key, namespace }: { key: string; namespace: string }) =>
      `${namespace}:${key}`,
    [],
  );

  const createUniqueOption = useCallback(
    (
      key: string,
      namespace: string,
      hasPluralization: boolean = false,
    ): ComboBoxOption => ({
      key,
      namespace,
      uniqueValue: createUniqueValue({ key, namespace }), // this is used for the combobox value as a unique identifier
      hasPluralization,
    }),
    [createUniqueValue],
  );

  const extractNamespaceKey = useCallback((uniqueValue: string) => {
    const [namespace, key] = uniqueValue.split(':');
    return {
      key,
      namespace,
    };
  }, []);

  return { createUniqueOption, createUniqueValue, extractNamespaceKey };
};
